import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { ConfirmGameSelectionButton } from "../BottomBar/BottomBarActionItems";
import { EventPackage } from "@/global/store/data/types";
import { useRouter } from "next/router";
import PartyIcon from "public/images/icon_party.svg";
import Image from "next/image";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { useRouterExtended } from "@/global/hooks/useRouterExtended";

interface Props {
  isOpen: boolean;
  selectedPackage: EventPackage | null;
}

export function PackageSelectionConfirmModal(props: Props) {
  const router = useRouterExtended();
  const { sm: smDown } = useCssMediaQuery("down");

  const handleClose = async () => {
    const query = { ...router.query };
    delete query.isPkgConfirmOpen;
    await router.replaceShallow({ query: query });
  };

  const handleConfirm = async () => {
    const cartConfirmBtn = document.getElementById(
      "confirm-game-selection-btn"
    );
    cartConfirmBtn?.click();
    await handleClose();
  };

  return (
    <ActionModal
      isOpen={props.isOpen}
      onClose={() => handleClose()}
      renderHeader={() => {
        return <Box></Box>;
      }}
      renderBody={() => {
        return (
          <Box>
            <Box p={4}>
              <Stack width={"100%"} alignItems={"center"}>
                <Image
                  alt="Package Selected Icon"
                  src={PartyIcon.src}
                  width={64}
                  height={64}
                />
              </Stack>

              <Box mt={4}>
                {props.selectedPackage ? (
                  <Box textAlign={"center"}>
                    <Typography
                      fontWeight={"700"}
                      fontSize={"1.2rem"}
                      lineHeight={1.4}
                      px={smDown ? 0 : 4}
                    >
                      The {props.selectedPackage.title} has been added to your
                      cart!
                    </Typography>
                    <Typography mt={2}>
                      Add more events or click Continue to select your seats.
                    </Typography>
                  </Box>
                ) : null}
              </Box>
            </Box>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"flex-end"}
            spacing={2}
          >
            <Box width={"180px"}>
              <ModalActionButton
                variant="primary"
                onClick={() => handleClose()}
                style={{ width: "100%" }}
              >
                Add More Events
              </ModalActionButton>
            </Box>
            <Box width={"180px"}>
              <ModalActionButton
                variant="primary"
                onClick={() => handleConfirm()}
                style={{ width: "100%" }}
              >
                Continue
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
